import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';

const WOMEN_TRAINING_IMG = 'https://customer-assets-4nw71qhi.emergentagent.net/job_elite-coaching-15/artifacts/w8z4ms70_women%20training.png';

const bullets = [
  'Become strong again',
  'Build lean muscle not chase a number',
  'Stop guessing and follow a plan',
  'Stay consistent through a busy schedule',
  'Get real accountability',
  'Move with confidence and athleticism',
];

const Placeholder = () => (
  <div className="relative w-full h-full min-h-[280px] overflow-hidden">
    <img
      src={WOMEN_TRAINING_IMG}
      alt="Women training at home"
      loading="lazy"
      className="absolute inset-0 w-full h-full object-cover"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
  </div>
);

export const WhoThisIsFor = () => {
  return (
    <section
      data-testid="who-this-is-for"
      className="bg-black py-14 sm:py-16 lg:py-20 px-6 border-b border-neutral-900"
    >
      <div className="container mx-auto max-w-7xl">
        <div className="grid lg:grid-cols-[1fr_1.3fr] gap-8 lg:gap-14 items-stretch">
          {/* Left: photo */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-40px' }}
            transition={{ duration: 0.8 }}
            className="relative rounded-2xl overflow-hidden border border-neutral-800"
          >
            <Placeholder />
          </motion.div>

          {/* Right: copy */}
          <div className="flex flex-col justify-center">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-40px' }}
              transition={{ duration: 0.7 }}
            >
              <div className="flex items-baseline gap-4 mb-2">
                <span className="font-display text-gray-500 text-2xl">1.</span>
                <p className="text-gray-400 font-bold text-xs tracking-[0.35em] uppercase">
                  Who This Is For
                </p>
              </div>
              <h2 className="font-display text-white text-4xl sm:text-5xl lg:text-6xl uppercase leading-none mt-4">
                For Women Ready To Feel Athletic Again.
              </h2>
              <p className="text-gray-400 text-sm sm:text-base mt-5 max-w-2xl leading-relaxed">
                Built primarily for women 30+ who want strength, lean muscle, structure, and sustainable
                habits whether or not they ever played a competitive sport.
              </p>
            </motion.div>

            <motion.ul
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-40px' }}
              transition={{ duration: 0.7, delay: 0.15 }}
              className="grid sm:grid-cols-2 gap-x-8 gap-y-3 mt-8"
            >
              {bullets.map((b) => (
                <li key={b} className="flex items-center gap-3 text-white text-sm sm:text-base">
                  <CheckCircle2 className="w-5 h-5 text-gray-300 shrink-0" strokeWidth={1.5} />
                  <span>{b}</span>
                </li>
              ))}
            </motion.ul>
          </div>
        </div>
      </div>
    </section>
  );
};
